const urls = {
    base_url: process.env.REACT_APP_BASE_URL,
    vendor: "vendor",
    procurement: "proc_mgmt",
}

export default urls
